import {getSpiideoVenueLabel} from '@modules/spiideoMappings/utils/helpers';
import {columnObjectAlignLeft} from '@utils/tableHelpers';

export const Columns = {
    'venue': {
        label: 'Venue',
        width: 8,
        ...columnObjectAlignLeft,
        sorting: (row) => getSpiideoVenueLabel(row.stadium).toLowerCase(),
    },
    'spiideo_scene_uuid': {
        label: 'Spiideo scene UUID',
        width: 8,
        ...columnObjectAlignLeft,
        sorting: (row) => (row.spiideo_scene_uuid || '').toLowerCase(),
    },
    'actions': {
        label: 'Actions',
        header: {
            align: 'center',
            isCollapsed: true,
        },
        content: {
            align: 'center',
        },
    },
};
